import type { NavigateFunction, NavigateOptions } from "react-router-dom";
import type { SlidePageTransitionDirection } from "../../components/transitions/SlidePageTransition";

export const parentOverviewPath = "/family/parents";
export const parentCreatePath = "/family/parents/new";
export const parentDetailsPath = (id: string) => `/family/parent/${id}/details`;
export const parentEditPath = (id: string) => `/family/parent/${id}/edit`;

export const parentFlowTransitionState = (direction: SlidePageTransitionDirection) => ({
  transitionDirection: direction,
});

export const navigateParentFlow = (
  navigate: NavigateFunction,
  to: string,
  direction: SlidePageTransitionDirection,
  options: Omit<NavigateOptions, "state"> = {}
) => {
  navigate(to, {
    ...options,
    state: parentFlowTransitionState(direction),
  });
};
